import { render } from "./service-chat-page.vue?vue&type=template&id=a16dd18e&scoped=true"
import script from "./service-chat-page.vue?vue&type=script&lang=js"
export * from "./service-chat-page.vue?vue&type=script&lang=js"

import "./service-chat-page.vue?vue&type=style&index=0&id=a16dd18e&lang=scss"
import "./service-chat-page.vue?vue&type=style&index=1&id=a16dd18e&lang=scss&scoped=true"

import exportComponent from "/Users/apple/Documents/Full Stack Projects/elghoneimy-service-fullstack/source/admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a16dd18e"]])

export default __exports__